import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';

// Styles
import styles from './LeftPanel.styl';

const cx = classNames.bind(styles);

export default function LeftPanel(props) {
  const {
    className,
    orderData: { client_number },
  } = props;

  const intl = useIntl();

  return (
    <div className={cx('LeftPanel', className)}>
      <span style={{ color: '#a69895' }}>
        {intl.formatMessage({ id: 'field.orderNumber.label' })}:
      </span>
      &nbsp;
      {client_number || <div className={cx('LeftPanel__spinner')} />}
    </div>
  );
}

LeftPanel.defaultProps = {
  className: '',
};

LeftPanel.propTypes = {
  className: PropTypes.string,
  orderData: PropTypes.object.isRequired,
};
